import { SettingsIcon } from '@chakra-ui/icons';
import { Box, Center, IconButton, Input } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { useXarrow } from 'react-xarrows';
import usePipelineStore from '../../stores/pipeline-store';
import useRuntimeStore from '../../stores/runtime-store';

interface StepNodeProps {
    stepId: string;
}
const StepNode: React.FC<StepNodeProps> = ({ stepId }) => {
    const { setSelectedStepId, setArrowRefs } = useRuntimeStore((state: any) => state);
    const { pipeline, setStepPosition, updateStep, setPipeline } = usePipelineStore((state: any) => state);
    const step = pipeline.steps[stepId] as PipelineStep;
    const [position, setPosition] = useState({ x: -1, y: -1 });
    useXarrow();
    const nodeRef = useRef(null);
    useEffect(() => {
        setArrowRefs(stepId, {
            center: `${stepId}_center`,
            up: `${stepId}_up`,
            down: `${stepId}_down`,
            right: `${stepId}_right`,
            left: `${stepId}_left`,
        });
    }, []);
    const stepIcon = {
        EMPTY: '⛅️',
        SEND_MESSAGE: '📟',
        CREATE_SURVEY_LINK: '🌐',
        GET_ANSWER_VALUES: '📜',
        SET_VAR: '📝',
        GENERATE_STORY: '🍙',
        MODERATOR_INPUT: '👮',
        EXTERNAL_REQUEST: '🌪',
        FINISH: '🌜',
        CREATE_DASHBOARD: '🖥️',
    }[step.type];

    return (
        <>
            {/* @ts-ignore */}
            <Draggable
                nodeRef={nodeRef}
                bounds="parent"
                position={step.editorSettings.position}
                defaultPosition={step?.editorSettings.position}
                scale={1}
                // grid={[25, 25]}
                onDrag={(d, ui) => {
                    setPosition({
                        x: ui.x,
                        y: ui.y,
                    });
                }}
                onStop={() => {
                    if (position.x == -1 && position.y == -1) {
                        return;
                    }
                    setStepPosition(stepId, position);
                }}
                onStart={() => {
                    const newPipeline = JSON.parse(JSON.stringify(pipeline));
                    newPipeline.steps[stepId].editorSettings.zIndex = 100000;
                    const sortedIds = Object.keys(newPipeline.steps).sort((a: string, b: string) => {
                        return newPipeline.steps[a].editorSettings.zIndex - newPipeline.steps[b].editorSettings.zIndex;
                    });
                    for (var i = 0; i < sortedIds.length; i++) {
                        newPipeline.steps[sortedIds[i]].editorSettings.zIndex = 10 + i;
                    }

                    setPipeline(newPipeline);
                }}
            >
                <Box
                    style={{ position: 'absolute' }}
                    zIndex={step.editorSettings.zIndex}
                    ref={nodeRef}
                    w={250 + Math.max(0, step.name.length - 25) * 7}
                    h={70}
                    border={pipeline.firstStepId == stepId ? '4px' : '2px'}
                    borderStyle={pipeline.firstStepId == stepId ? 'dotted' : 'solid'}
                    borderColor={step.editorSettings.color}
                    bgColor={'white'}
                >
                    <>
                        <div
                            style={{
                                opacity: 0.5,
                                position: 'absolute',
                                left: '0',
                                top: '0',
                            }}
                        >
                            {stepIcon}
                        </div>
                        <div
                            id={`${stepId}_center`}
                            style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                            }}
                        ></div>
                        <div
                            id={`${stepId}_up`}
                            style={{
                                position: 'absolute',
                                left: '50%',
                                top: '-5px',
                            }}
                        />

                        <div
                            id={`${stepId}_right`}
                            style={{
                                position: 'absolute',
                                right: '-5px',
                                top: '50%',
                            }}
                        />

                        <div
                            id={`${stepId}_down`}
                            style={{
                                position: 'absolute',
                                left: '50%',
                                bottom: '-5px',
                            }}
                        />

                        <div
                            id={`${stepId}_left`}
                            style={{
                                position: 'absolute',
                                left: '-5px',
                                top: '50%',
                            }}
                        />
                    </>

                    <Center h={'100%'}>
                        <Input
                            value={step.name}
                            textAlign={'center'}
                            border={'none'}
                            focusBorderColor={'none'}
                            onChange={({ target: { value } }: any) => {
                                updateStep(stepId, 'name', value);
                            }}
                        />
                    </Center>

                    <IconButton
                        style={{ position: 'fixed', top: 1, right: 1 }}
                        m={-2}
                        variant={'outline'}
                        borderWidth={0}
                        _hover={{
                            backgroundColor: 'transparent',
                            color: 'black',
                        }}
                        _focus={{
                            backgroundColor: 'transparent',
                        }}
                        _active={{
                            backgroundColor: 'transparent',
                        }}
                        color={'grey'}
                        aria-label="Send email"
                        onClick={() => {
                            setSelectedStepId(stepId);
                        }}
                        icon={<SettingsIcon />}
                    />
                </Box>
            </Draggable>
        </>
    );
};

export default StepNode;
